__turbopack_context__.v({
  "black": "Jr-v2a_black",
  "black100": "Jr-v2a_black100",
  "black1000": "Jr-v2a_black1000",
  "black200": "Jr-v2a_black200",
  "black300": "Jr-v2a_black300",
  "black400": "Jr-v2a_black400",
  "black500": "Jr-v2a_black500",
  "black600": "Jr-v2a_black600",
  "black700": "Jr-v2a_black700",
  "black800": "Jr-v2a_black800",
  "black900": "Jr-v2a_black900",
  "blue200": "Jr-v2a_blue200",
  "blue400": "Jr-v2a_blue400",
  "blue600": "Jr-v2a_blue600",
  "blue800": "Jr-v2a_blue800",
  "blue900": "Jr-v2a_blue900",
  "contentWrapper": "Jr-v2a_contentWrapper",
  "green200": "Jr-v2a_green200",
  "green400": "Jr-v2a_green400",
  "green600": "Jr-v2a_green600",
  "green800": "Jr-v2a_green800",
  "green900": "Jr-v2a_green900",
  "gridWrapper": "Jr-v2a_gridWrapper",
  "heading": "Jr-v2a_heading",
  "imageContainer": "Jr-v2a_imageContainer",
  "imageWrapper": "Jr-v2a_imageWrapper",
  "inlineLink": "Jr-v2a_inlineLink",
  "label": "Jr-v2a_label",
  "largeHeading": "Jr-v2a_largeHeading",
  "mediumHeading": "Jr-v2a_mediumHeading",
  "pageHeader": "Jr-v2a_pageHeader",
  "pageHeaderWeb3Theme": "Jr-v2a_pageHeaderWeb3Theme",
  "pageHeaderWithVideo": "Jr-v2a_pageHeaderWithVideo",
  "pageHeaderWithoutHeightRestriction": "Jr-v2a_pageHeaderWithoutHeightRestriction",
  "pink200": "Jr-v2a_pink200",
  "pink400": "Jr-v2a_pink400",
  "pink600": "Jr-v2a_pink600",
  "pink800": "Jr-v2a_pink800",
  "purple200": "Jr-v2a_purple200",
  "purple400": "Jr-v2a_purple400",
  "purple600": "Jr-v2a_purple600",
  "purple800": "Jr-v2a_purple800",
  "purple900": "Jr-v2a_purple900",
  "red200": "Jr-v2a_red200",
  "red400": "Jr-v2a_red400",
  "red600": "Jr-v2a_red600",
  "red800": "Jr-v2a_red800",
  "red900": "Jr-v2a_red900",
  "search": "Jr-v2a_search",
  "sky1000": "Jr-v2a_sky1000",
  "smallerImageContainer": "Jr-v2a_smallerImageContainer",
  "useCaseLendingRed": "Jr-v2a_useCaseLendingRed",
  "white": "Jr-v2a_white",
  "yellow200": "Jr-v2a_yellow200",
  "yellow400": "Jr-v2a_yellow400",
  "yellow600": "Jr-v2a_yellow600",
  "yellow800": "Jr-v2a_yellow800",
  "yellow900": "Jr-v2a_yellow900",
});
